import React from 'react'
import Header from '../Layout/Header'
import Footer from '../Layout/Footer'

function BlogGrid() {
  return (
    <div>
            <Header/>
        {/* <!-- Breadcrumb Section Start --> */}
        <div class="gt-breadcrumb-wrapper bg-cover"   style={{
    backgroundImage: "url('/assets/img/breadcrumb-bg.jpg')"
 
  }}>
            <div class="container">
                <div class="gt-page-heading">
                    <div class="gt-breadcrumb-sub-title">
                        <h1 class="wow fadeInUp" data-wow-delay=".3s">Blog Post</h1>
                    </div>
                    <ul class="gt-breadcrumb-items wow fadeInUp" data-wow-delay=".5s">
                        <li>
                            <a href="index-2.html">
                                Home
                            </a>
                        </li>
                        <li>
                            <i class="fa-solid fa-chevron-right"></i>
                        </li>
                        <li>
                           Blog Post
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        {/* <!-- GT News Section Start --> */}
        <section class="gt-news-section section-padding">
            <div class="container">
                <div class="row g-4">
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-01.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-01.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                       Tips & Tricks
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">How to Stage Your Home to Sell Faster</a>
                                </h3>
                                <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-02.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-02.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                       Hotel
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">Buying vs. Renting – Which Is Right for You?</a>
                                </h3>
                                 <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-03.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-03.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                      Tips & Enjoy
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">Why London Is a Great Place to Settle Down</a>
                                </h3>
                                 <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-04.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-04.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                       Tips & Tricks
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">Is Renting or Buying Better for You?</a>
                                </h3>
                                <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-05.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-05.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                       Hotel
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">Eco-Friendly Features That Modern Buyers Love</a>
                                </h3>
                                 <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-06.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-06.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                      Tips & Enjoy
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">Understanding Market Trends in Real Estate</a>
                                </h3>
                                 <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".3s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-07.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-07.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                       Tips & Tricks
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">How to Sell Your Home Without a Realtor</a>
                                </h3>
                                <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".5s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-08.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-08.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                       Hotel
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">What Makes a Property ‘Move-In Ready’?</a>
                                </h3>
                                 <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay=".7s">
                        <div class="gt-news-box-items mt-0">
                            <div class="gt-thumb">
                                <img src="assets/img/home-1/news/news-09.jpg" alt="img"/>
                                <img src="assets/img/home-1/news/news-09.jpg" alt="img"/>
                            </div>
                            <div class="gt-content">
                                <ul class="gt-list">
                                    <li>
                                        <i class="fa-solid fa-calendar-days"></i>
                                        April 12, 2025
                                    </li>
                                    <li>
                                      Tips & Enjoy
                                    </li>
                                </ul>
                                <h3>
                                    <a href="news-details.html">A Step-by-Step Home Buying Checklist</a>
                                </h3>
                                 <a href="news-details.html" class="theme-btn">Read More <i class="flaticon-right-arrow"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page-nav-wrap text-center">
                    <ul>
                        <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-left"></i></a></li>
                        <li class="active"><a class="page-numbers" href="#">01</a></li>
                        <li><a class="page-numbers" href="#">02</a></li>
                        <li><a class="page-numbers" href="#">03</a></li>
                        <li><a class="page-numbers" href="#"><i class="fa-solid fa-chevron-right"></i></a></li>
                    </ul>
                </div>
            </div>
        </section>
<Footer />
    </div>
  )
}

export default BlogGrid